query NewPurchaseOrderData($id: UUID!) {
  purchaseOrder(id: $id) {
    __typename
    id
    _urgencyLevel
    _isUpdatable
    sortSupplierName
    _isDeletable
    purchaseOrderType {
      purchaseOrderType
    }
    _appliedTotals {
      usedAmount
      remainingAmount
      appliedAmount
      retiredAmount
      overageAmount
    }
    purchaseOrderNumber
    purchaseOrderDate
    sortSupplierName
    description

    department {
      name
      id
    }
    businessUnit {
      id
      name
    }
    currency {
      id
      isoCode
      currencySymbol
    }
    controlTotalAmount
    _statusTypeId
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    _rowTimestamp
    _referenceItemTypes
    _accountingStampTransactionReference
    _createdByUserName
    _createdDate
    _baseCurrencyAmount
    _spotCurrencyAmount
    _isStagedApprovalRequest
    _pendingApprovers
    _isAccountingEntryStampedComplete
    _isAccountingEntry
  }
}
